import React, { ReactNode } from 'react';
import { Box, Text } from '@mafc/trolly';
import COLORS from 'theme/colors';
import { InfoWrapperStyle } from './InfoWrapper.style';

const InfoWrapper: React.FC<{
  headingText: string;
  icon: ReactNode;
  children: ReactNode;
  backgroundColor?: string;
  marginBottom?: string;
}> = ({ headingText, icon, children, backgroundColor, marginBottom }) => {
  return (
    <InfoWrapperStyle backgroundColor={backgroundColor}>
      <Box display="flex" mb={marginBottom || 2} alignItems="center">
        <Box
          mr={12}
          sx={{
            minWidth: '18px',
          }}
        >
          {icon}
        </Box>

        <Text fontSize={2} fontWeight={5} color={COLORS.BLACK}>
          {headingText}
        </Text>
      </Box>

      {children}
    </InfoWrapperStyle>
  );
};

export default InfoWrapper;
